import React from "react";
import { TIME_FILTERS } from "../../utils/matchFilters";

/* Today / Tomorrow / Live plus a team search.
 *
 * Cricket alone runs to sixteen simultaneous markets on an ordinary day and
 * the list is only going to grow, so scrolling was the only way to find a
 * specific match.
 */
const SportFilters = ({ timeFilter, setTimeFilter, teamQuery, setTeamQuery }) => (
  <div className="rb-filters">
    {TIME_FILTERS.map((f) => (
      <button
        type="button"
        key={f.key}
        className={timeFilter === f.key ? "rb-chip rb-chip--active" : "rb-chip"}
        aria-pressed={timeFilter === f.key}
        onClick={() => setTimeFilter(f.key)}
      >
        {f.label}
      </button>
    ))}
    <label className="rb-search">
      <i className="fa fa-search" aria-hidden="true" />
      <input
        type="search"
        value={teamQuery || ""}
        placeholder="Search teams"
        aria-label="Search teams"
        onChange={(e) => setTeamQuery(e.target.value)}
      />
    </label>
  </div>
);

export default SportFilters;
